import { Component } from 'react'
import { Choice, Code, CodeableConcepts, CodeableConcept, Components } from '../helpers'
import { GiNurseFemale } from 'react-icons/gi'

import './resource.css'

class ServiceRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiNurseFemale /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.intent && 'Intent'}</div>
                            <div className='Res-Title'>{this.props.resource.intent && Code(this.props.resource.intent)}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.priority && 'Priority'}</div>
                            <div className='Res-Title'>{this.props.resource.priority && Code(this.props.resource.priority)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Service'}</div>
                        <div className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.orderDetail && 'Details'}</div>
                        <div className='Res-Title'>{this.props.resource.orderDetail && CodeableConcepts(this.props.resource.orderDetail)}</div>
                    </div>
                    <div className='Res-row'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.quantityQuantity || this.props.resource.quantityRange || this.props.resource.quantityRatio) && 'Quantity'}</div>
                        </div>
                        <div>
                            {this.props.resource.quantityQuantity && <div className='Res-Title'>{Choice('Quantity', this.props.resource.quantityQuantity)}</div>}
                            {this.props.resource.quantityRange && <div className='Res-Title'>{Choice('Quantity', this.props.resource.quantityRange)}</div>}
                            {this.props.resource.quantityRatio && <div className='Res-Title'>{Choice('Quantity', this.props.resource.quantityRatio)}</div>}
                        </div>
                    </div>
                    <div className='Res-row'>
                        <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.occurrenceDateTime || this.props.resource.occurrencePeriod || this.props.resource.occurrenceTiming) && 'Occurrence'}</div>
                        {this.props.resource.occurrenceDateTime && <div className='Res-Detail'>{Choice('DateTime', this.props.resource.occurrenceDateTime)}</div>}
                        {this.props.resource.occurrencePeriod && <div className='Res-Detail'>{Choice('Period', this.props.resource.occurrencePeriod)}</div>}
                        {this.props.resource.occurrenceTiming && <div className='Res-Detail'>{Choice('Timing', this.props.resource.occurrenceTiming)}</div>}
                    </div>
                    <div className='Res-row'>
                        {this.props.resource.asNeededBoolean && <div className='Res-Detail'>{this.props.resource.asNeededBoolean && '*As Needed'}</div>}
                        {this.props.resource.asNeededCodeableConcept && <div className='Res-Detail'>{Choice('CodeableConcept', this.props.resource.asNeededCodeableConcept)}</div>}
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.method && 'Method'}</div>
                            {this.props.resource.method && <div className='Res-Title'>{CodeableConcept(this.props.resource.method)}</div>}
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.interpretation && 'Interpretation'}</div>
                            {this.props.resource.interpretation && <div className='Res-Title'>{CodeableConcepts(this.props.resource.interpretation)}</div>}
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.bodySite && 'Body Site'}</div>
                            {this.props.resource.bodySite && <div className='Res-Title'>{CodeableConcept(this.props.resource.bodySite)}</div>}
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.component) && 'Results'}</div>
                            {this.props.resource.component && <div className='Res-Title'>{Components(this.props.resource.component)}</div>}
                        </div>
                    </div>
                </div>
            }
        </div></div>
    }
}

export default ServiceRequest